import { startRegistration, startAuthentication, browserSupportsWebAuthn } from "@simplewebauthn/browser";

export const passkeysSupported = () => {
  try { return browserSupportsWebAuthn(); } catch { return false; }
};

export const runRegistration = (optionsJSON) => startRegistration({ optionsJSON });
export const runAuthentication = (optionsJSON) => startAuthentication({ optionsJSON });
